import { customAxios,  PROFORMA_URL } from '../constants';

export default function(codAreaVta, codFamiliaVeh) {
    
const config = {
  headers: {
    cantidadxPag: 10,
    numPag:1,
  },
 };

  const data = {
    codAreaVta : codAreaVta,
    codFamiliaVeh : '',
    idTipoDato : '3',
    indInactivo : 'N',
  };
  
  return customAxios.post(`${PROFORMA_URL}/mantenimiento/datoMaestro/datoMaestroListar`, data, config);

}
  



// WEBPACK FOOTER //
// ./src/utils/getCorteProgramacion.js